import { Controller } from "@hotwired/stimulus"

// The ⋮ menu on a project's chat rows (assistant_projects/_chats): Pin, Rename,
// Delete - the same endpoints the left sidebar's menu calls, then the page reloads
// so the lists re-sort on the server.
export default class extends Controller {
    static targets = ["title"]
    static values = { pinUrl: String, renameUrl: String, deleteUrl: String }

    async togglePin(event) {
        const row = this._row(event)
        const pinned = row.dataset.pinned !== "true"
        if (await this._request("POST", this.pinUrlValue, { conversation_id: row.dataset.conversationId, pinned: pinned ? "1" : "0" })) this._reload()
    }

    rename(event) {
        const row = this._row(event)
        const title = row.querySelector(".project-chat-title")
        const link = row.querySelector(".project-chat-link")
        const before = title.textContent.trim()
        const input = document.createElement("input")
        input.type = "text"
        input.value = before
        input.maxLength = 120
        input.className = "form-control form-control-sm project-chat-rename"
        input.setAttribute("aria-label", "Chat title")
        link.hidden = true
        link.after(input)
        input.focus()
        input.select()

        let done = false
        const finish = async (save) => {
            if (done) return
            done = true
            const next = input.value.trim()
            input.remove()
            link.hidden = false
            if (!save || !next || next === before) return
            if (await this._request("POST", this.renameUrlValue, { conversation_id: row.dataset.conversationId, title: next })) this._reload()
        }
        input.addEventListener("keydown", (e) => {
            if (e.key === "Enter") { e.preventDefault(); finish(true) }
            if (e.key === "Escape") { e.preventDefault(); finish(false) }
        })
        input.addEventListener("blur", () => finish(true))
    }

    async destroy(event) {
        const row = this._row(event)
        if (!window.confirm("Delete this conversation for good? This can't be undone.")) return

        if (await this._request("DELETE", this.deleteUrlValue, { conversation_id: row.dataset.conversationId })) row.remove()
    }

    _row(event) {
        return event.currentTarget.closest("[data-conversation-id]")
    }

    async _request(method, url, body) {
        try {
            const response = await fetch(url, {
                method,
                headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "" },
                credentials: "same-origin",
                body: JSON.stringify(body)
            })
            return response.ok
        } catch {
            return false
        }
    }

    _reload() {
        if (window.Turbo?.visit) window.Turbo.visit(window.location.href, { action: "replace" })
        else window.location.reload()
    }
}
